import { themeVars } from '../theme/vars';
import { borderRadius, space } from '../tokens';
import { typography } from '../typography';
import { style, styleVariants } from '../layer.css';

export const selectionTag = style({
  cursor: 'pointer',
  borderRadius: borderRadius.r32,
  backgroundColor: themeVars.tag.selection.background.idle,
  border: `1px solid ${themeVars.tag.selection.border}`,
  color: themeVars.tag.selection.foreground,
  userSelect: 'none',
  transition: '.15s',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  ':hover': {
    backgroundColor: themeVars.tag.selection.background.hover,
  },
  ':active': {
    backgroundColor: themeVars.tag.selection.background.active,
  },

  ':disabled': {
    cursor: 'default',
    backgroundColor: themeVars.tag.disabled.background,
    color: themeVars.tag.disabled.foreground,
  },

  selectors: {
    '&:where([aria-checked="true"], &[aria-pressed="true"])': {
      backgroundColor: themeVars.tag.selection.background.selected,
      borderColor: themeVars.tag.selection.background.active,
    },
  },
});

export const selectionTagSize = styleVariants({
  sm: [
    typography['labelSm'],
    {
      height: 24,
      padding: `${space.s2}px ${space.s8}px`,
    },
  ],
  md: [
    typography['labelMd'],
    {
      height: 32,
      padding: `${space.s6}px ${space.s12}px`,
    },
  ],
});

export type SelectionTagSize = keyof typeof selectionTagSize;
